<template>
    <div >
		<div id="dataCard_profile_0" class="data-card__form data-card__form--full accordion-body collapse" aria-expanded="false" style="">
			<!--<a  href="" class="button button--th-error js-remove-profile-remove"
			   v-on:click="removeProfile">
				Удалить <br> профиль
			</a>-->
			<div class="data-card__inner accordion-body__inner">
				<div class="b-form-sm">
					<div class="b-form-sm__body js-remove-profile" style="justify-content:right">
						<div class="b-form-sm__item b-form-sm__item--row b-form-sm__item--auto b-form-sm__item--right">
							<!-- капча -->
							<div v-if="!checkCapchaCode" class="register-form__row js-capcha-show-container">
								<div class="data-card__form-button data-card__form-button--lg txt-input__input">
									<input type="text" class="txt-input__field input req js-capcha-input"
										   v-on:change="checkCaptchaButtonAction()"
										   v-on:input="checkCaptchaButtonAction()"
										   id="checkCaptcha"
										   maxlength="8"
										   v-model="inputCapchaCode"
										   placeholder="Введите капчу">
									<div v-if="!checkCapchaCode" class="txt-input__required txt-input__required--error txt-input__required--dbl">{{capchaError}}</div>
								</div>
								<div class="data-card__form-button data-card__form-button--lg capcha-image js-capcha-image"
									 id="captchaImage">
									<img src="/Profiles/Captcha?captchaLen=7">
								</div>
								<a href="#dataCard_profile_0" class="data-card__form-button data-card__form-button--lg button button--th-main js-capcha-next-trigger js-capcha-hidden-block-entering"
								   data-target="#dataCard_profile" data-toggle="collapse" style="display: none; align-content:center" aria-expanded="true"
								   id="checkCaptchaButton"
								   v-on:click="checkCaptcha">OK</a>
							</div>


						</div>
					</div>
				</div>
			</div>
		</div>

        <div v-if="checkCapchaCode" id="dataCard_profile" class="data-card__form data-card__form--full accordion-body collapse in">
            <div class="data-card__inner accordion-body__inner js-remove-profile-container">
                <div class="b-form-sm">
                    <div class="remove-profile__title">Выберите способ отправки кода для удаления профиля</div>
                    <div class="remove-profile__item js-remove-profile">
                        <div v-if="!inputEmailCodeEnabled" class="remove-profile__head">
                            <span class="remove-profile__text">Адрес электроной почты: <span class="status-primary">{{email}}</span></span>
                            <a v-if="isemailverified=='false'" href="#" class="remove-profile__error status-error link link--present"><span class="link__text">Не подтвержден</span></a>
                        </div>
                        <div class="b-form-sm__body">
                            <div class="b-form-sm__item--md">
                                <label v-if="!inputEmailCodeEnabled" class="txt-input js-input-contact">
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input" type="text" v-model="email">
                                    </div>
                                </label>
								<label v-if="inputEmailCodeEnabled" class="txt-input js-input-code">
									<div class="txt-input__input">
										<input class="txt-input__field input" type="text" placeholder="код"
											   maxlength="5"
											   :class="isEmailVerified==-1 ? 'is-error':''"
											   v-model="emailCode">
									</div>
									<div v-if="isEmailVerified==-1" class="txt-input__required txt-input__required--error">{{emailVerifyError}}</div>
								</label>
                            </div>
							<div class="b-form-sm__item remove-buttons-container" style="margin-left:10px">
								<a v-if="!sendEmailCodeEnabled" href="" class="button button-icon--th-ctrl is-disable" style="width:110px">Недоступно</a>
								<button v-if="sendEmailCodeEnabled && !inputEmailCodeEnabled" class="button button--th-second js-remove-profile-trigger" style="width:110px"
										:class="sendEmailCodeEnabled ? '':'is-disable'"
										v-on:click="sendEmailCode">
									Получить код
								</button>
								
								<div v-if="inputEmailCodeEnabled && !emailProfileRemoveEnabled && timerEmailShow" class="form-timer form-timer--profile js-timer is-show">
									<svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
										<path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
										M 50, 50
										m -45, 0
										a 45,45 0 1,0 90,0
										a 45,45 0 1,0 -90,0
										"></path>
									</svg>
									<span class="js-timer-count form-timer__count">
										{{counterEmail}}
									</span>
								</div>

								<button v-if="inputEmailCodeEnabled && !emailProfileRemoveEnabled" class="button button--th-main js-remove-profile-next" style="width:110px"
										v-on:click="verifyEmailCheckCode">
									Продолжить
								</button>
								<button v-if="sendEmailCodeAgainEnabled"  class="button button--th-main js-profile-code-again" style="width:110px"
										v-on:click="sendEmailCode">
									Отправить <br>еще раз
								</button>
								<a v-if="emailProfileRemoveEnabled" href="" class="button button--th-error js-remove-profile-remove" style="width:110px"
								   v-on:click="removeProfile">
								Удалить <br> профиль</a>
								<a href="#dataCard_profile" class="button button--th-second" data-toggle="collapse" style="width:110px"
								   v-on:click="cancelRemoveProfile">
								Отменить</a>
							</div>
                        </div>
                    </div>
                    <div class="remove-profile__item js-remove-profile">
                        <div v-if="!inputPhoneCodeEnabled" class="remove-profile__head">
                            <span class="remove-profile__text">Номер сотового телефона: <span class="status-primary">{{phone}}</span></span>
                            <a v-if="isphonenumberverified=='false'" href="#" class="remove-profile__error status-error link link--present"><span class="link__text">Не подтвержден</span></a>
                        </div>
                        <div class="b-form-sm__body">
                            <div class="b-form-sm__item--md">
                                <label v-if="!inputPhoneCodeEnabled" class="txt-input js-input-contact">
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input" type="text" v-model="phone">
                                    </div>
                                </label>
                                <label v-if="inputPhoneCodeEnabled" class="txt-input js-input-code">
                                    <div class="txt-input__input">
                                        <input class="txt-input__field input" type="text" placeholder="код" 
											   maxlength="5"
											   :class="isPhoneVerified==-1 ? 'is-error':''"
											   v-model="phoneCode">
                                    </div>
									<div v-if="isPhoneVerified==-1" class="txt-input__required txt-input__required--error">{{phoneVerifyError}}</div>
                                </label>
                            </div>
							<div class="b-form-sm__item remove-buttons-container" style="margin-left:10px">
								<a v-if="!sendPhoneCodeEnabled" href="" class="button button-icon--th-ctrl is-disable" style="width:110px">Недоступно</a>
								<button v-if="sendPhoneCodeEnabled && !inputPhoneCodeEnabled" class="button button--th-second js-remove-profile-trigger" style="width:110px"
										:class="sendPhoneCodeEnabled ? '':'is-disable'"
										v-on:click="sendPhoneCode">
									Получить код
								</button>

								<div v-if="inputPhoneCodeEnabled && !phoneProfileRemoveEnabled && timerPhoneShow" class="form-timer form-timer--profile js-timer is-show">
									<svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
										<path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
											M 50, 50
											m -45, 0
											a 45,45 0 1,0 90,0
											a 45,45 0 1,0 -90,0
											"></path>
									</svg>
									<span class="js-timer-count form-timer__count">
										{{counterPhone}}
									</span>
								</div>

								<button v-if="inputPhoneCodeEnabled && !phoneProfileRemoveEnabled" class="button button--th-main js-remove-profile-next" style="width:110px"
										v-on:click="verifyPhoneCheckCode">
									Продолжить
								</button>
								<button v-if="sendPhoneCodeAgainEnabled" class="button button--th-main js-profile-code-again" style="width:110px"
										v-on:click="sendPhoneCode">
									Отправить еще раз
								</button>
								<a v-if="phoneProfileRemoveEnabled" href="" class="button button--th-error js-remove-profile-remove" style="width:110px"
								   v-on:click="removeProfile">
								Удалить <br> профиль</a>
								<a href="#dataCard_profile" class="button button--th-second" data-toggle="collapse" style="width:110px"
								   v-on:click="cancelRemoveProfile">
								Отменить</a>
							</div>
                        </div>
                    </div>
                    <div v-if="(inputPhoneCodeEnabled && !phoneProfileRemoveEnabled) || (inputEmailCodeEnabled && !emailProfileRemoveEnabled)" class="remove-profile__item js-remove-profile-message">
                        <div class="status-error">
                            Введите проверочный код и нажмите кнопку "Продолжить" для удаления вашего профиля.
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

  
    import MaskedInput from 'vue-masked-input';

    const { required, minLength } = window.validators
    const { validationMixin } = window.vuelidate

    export default {
        mixins: [validationMixin],
        props: ['user', 'isemailverified', 'isphonenumberverified'],
        components: {
           
            'masked-input': MaskedInput
        },
        data: function () {
            return {
                isServerVerify: false,
                isValidateErrors: false,
                serverMessage: [],
                serverErrors: '',
                serverResponse: '',

                inputCapchaCode: "",
				checkCapchaCode: false,
                capchaError: "",
				countCheck: 1,
				counter: 100,
				counterEmail: 100,
				counterPhone: 100,
				timerEmailShow: false,
				timerPhoneShow: false,

				lifeTimeCode: 300,
				phone: "",
				email: "",
				phoneExist: false,
				emailExist: false,
				sendPhoneCodeEnabled: false,
				sendEmailCodeEnabled: false,
				sendPhoneCodeAgainEnabled: false,
				sendEmailCodeAgainEnabled: false,
				phoneVerifyError: '',
				isPhoneVerified: 0,
				phoneCode: '',
				/// верификация email
				emailVerifyError: '',
				isEmailVerified: 0,
				emailCode: '',
				inputCode: '',
				inputPhoneCodeEnabled: false,
				inputEmailCodeEnabled: false,
				phoneProfileRemoveEnabled: false,
				emailProfileRemoveEnabled: false,
		
            }

        },
       

		created: function () {
			this.initData();
		},

		methods: {

			initData: function () {
				this.phone = this.user.PhoneNumber;
				this.email = this.user.Email;
				if (this.phone != null && this.phone != undefined && this.phone.length >= 10) this.phoneExist = true;
				if (this.email != null && this.email != undefined && this.email != '') this.emailExist = true;

				console.log('isemailverified = ' + this.isemailverified);
				console.log('isphonenumberverified = ' + this.isphonenumberverified); 
				if (this.phoneExist == true && this.isphonenumberverified == "true") this.sendPhoneCodeEnabled = true;
				if (this.emailExist == true && this.isemailverified == "true") this.sendEmailCodeEnabled = true;
			},

			checkCaptchaButtonAction: function () {

				var checkCaptchaButton = document.getElementById('checkCaptchaButton');
				var captchaImage = document.getElementById('captchaImage');

				if (checkCaptchaButton != undefined && captchaImage != undefined) {
					captchaImage.style.display = 'block';
					checkCaptchaButton.style.display = 'none';
					$(checkCaptchaButton).addClass('is-disable');
					if (this.inputCapchaCode.length > 6) {
						checkCaptchaButton.style.display = 'block';
						$(checkCaptchaButton).removeClass('is-disable');
						if (captchaImage != undefined) {
							captchaImage.style.display = 'none';
						}
					}
				}
            },

			checkCaptcha: function (event) {
				event.stopPropagation();

				console.log("checkCaptcha");

				const self = this;
				this.checkCapchaCode = false;
				this.capchaError = "";

				var count = this.getRandomInt(0, 100);
				var captchaImageId = '#captchaImage';

				axios.post('/Register/CheckCaptcha/' + self.inputCapchaCode)
					.then(function (response) {
						console.info('checkCaptcha', response);
						if (response.data.isSuccess) {

						}
						if (!response.data.isSuccess) {
							var countch = self.countCheck++;
							console.log("Count Check", countch);
							self.isValidateErrors = true;
							self.isServerVerify = false;
							self.checkCapchaCode = false;
							self.capchaError = "Код введен неверно";
						
							self.errorCaptcha();


							if (countch % 2 === 0) {
							//	var str = '<img src="/Profiles/Captcha/' + count + '">';
								var str = '<img src="/Profiles/Captcha/' + count + '?captchaLen=7">';
								console.log("String", str);
								$(captchaImageId).html(str);
								self.noErrorCaptcha();
								self.inputCapchaCode = "";
								self.checkCapchaCode = false;
								self.capchaError = "";

                                self.showHideCaptchaImage(true);
								self.showHideCheckCaptchaButton(false);
							}

						}
						else {
							self.checkCapchaCode = true;
							self.capchaError = "";
						

							self.noErrorCaptcha();
					
						}
					})
					.catch(function (error) {
						self.isValidateErrors = true;
						self.isServerVerify = false;

					});
            },

			getRandomInt: function (min, max) {
				min = Math.ceil(min);
				max = Math.floor(max);
				return Math.floor(Math.random() * (max - min) + min);
			},

			showHideCheckCaptchaButton: function (show) {
				var checkCaptchaButton = document.getElementById('checkCaptchaButton');

				if (checkCaptchaButton != undefined) {
					if (show == true) {
						checkCaptchaButton.style.display = 'block';
					}
					if (show == false) {
						checkCaptchaButton.style.display = 'none';
					}
				}
			},

			showHideCaptchaImage: function (show) {
				var captchaImage = document.getElementById('captchaImage');
				if (captchaImage != undefined) {
					if (show == true) {
						captchaImage.style.display = 'block';
					}
					if (show == false) {
						captchaImage.style.display = 'none';
					}
				}
			},

			errorCaptcha: function () {
				this.errorInput('checkCaptcha');
			},
	
			noErrorCaptcha: function () {
				this.noErrorInput('checkCaptcha');
            },

			errorInput: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					$(input).addClass('is-error');
				}
			},

			noErrorInput: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					$(input).removeClass('is-error');
				}
            },

			fixPhone: function (phone) {
				if (phone.length > 0) {
					//  var result = this.phone.replace(/[^+\d]/g, "")
					var result = this.phone.replace("+", "").replace("-", "").replace("-", "").replace("(", "").replace(")", "").replace(" ", "");

					if (result.length > 0) {
						if (result.length == 10 && result.substring(0, 1) !== "8" && result.substring(0, 1) !== "7") {
							result = "7" + result;
						}
					}
				}
				return result;
			},

			isValidatePhone: function (phone) {
				var result = false;
				if (phone.length > 0) {
					var phoneFixed = this.fixPhone(phone);
					if (phoneFixed.length == 11) {
						result = true;
					}
				}
				return result;
            },

			checkTimer(timer, fn) {
				var timerInterval = null;
				timerInterval = setInterval(function () {
					if (timer.css('display') != 'none') {
						fn();
						clearInterval(timerInterval);
					}
				}, 2000);
			},

			countdown: function () {
				var self = this;
	
				setTimeout(function () {
					if (self.counter <= 0) {
						//if (self.showInputCodeDiv[self.curOrderId] == true) self.showHideSendCodeAgainBlock(true, self.curOrderId);
						//self.hideInputCodeDev(self.curOrderId);
						
					} else {
						self.counter--;
						self.countdown();
					}

				},
					1000);
			},

			countdownEmail: function () {
				var self = this;
				
				self.sendEmailCodeAgainEnabled = false;
				setTimeout(function () {
					if (self.counterEmail <= 0) {
						//if (self.showInputCodeDiv[self.curOrderId] == true) self.showHideSendCodeAgainBlock(true, self.curOrderId);
						//self.hideInputCodeDev(self.curOrderId);
						self.sendEmailCodeAgainEnabled = true;
						self.timerEmailShow = false;

					} else {
						self.counterEmail--;
						self.countdownEmail();
					}

				},
					1000);
			},

			countdownPhone: function () {
				var self = this;
				//self.showHideSendCodeAgainBlock(false, self.curOrderId);
				//self.showInputCodeDev(self.curOrderId);
				self.sendPhoneCodeAgainEnabled = false;
				setTimeout(function () {
					if (self.counterPhone <= 0) {
						//if (self.showInputCodeDiv[self.curOrderId] == true) self.showHideSendCodeAgainBlock(true, self.curOrderId);
						//self.hideInputCodeDev(self.curOrderId);
						self.sendPhoneCodeAgainEnabled = true;
						self.timerPhoneShow = false;
						

					} else {
						self.counterPhone--;
						self.countdownPhone();
					}

				},
					1000);
			},

			sendPhoneCode: function (event) {
				event.stopPropagation();

				if (this.phone == null) {
					return;
				}

				var realPhone = this.fixPhone(this.phone);
				if (!this.isValidatePhone(this.phone)) {
					return;
				}

				const self = this;

				self.inputPhoneCodeEnabled = false;
				self.sendPhoneCodeAgainEnabled = false;

				console.log("sendPhoneCode");
				self.phoneVerifyError = '';
				self.isPhoneVerified = 0;
				self.phoneCode = '';
				self.inputCode = "";
				var tvalue = $('input[name="__RequestVerificationToken"]').val();
				let axiosConfig = {
					headers: { 'RequestVerificationToken': tvalue }
				};
				const data = {
				};
				console.info(self.phone);

				axios.post('/Profiles/SendPhoneCode/' + realPhone, data, axiosConfig)
					.then(function (response) {
						if (response.data.isSuccess) {
							console.log("sendPhoneCode: отправка успешная");

							self.counter = self.lifeTimeCode;
							self.counterPhone = self.lifeTimeCode;
							self.timerPhoneShow = true;
						
							self.countdownPhone();

						
							self.inputPhoneCodeEnabled = true;
						}
						if (!response.data.isSuccess) {
							self.isValidateErrors = true;
							self.isServerVerify = false;
							self.phoneVerifyError = response.data.message.join('');
							console.log("sendPhoneCode: отправка неуспешная");

							self.counter = self.lifeTimeCode;
							self.counterPhone = self.lifeTimeCode;
							self.timerPhoneShow = true;

						
							self.countdownPhone();
							self.inputPhoneCodeEnabled = true;

						
						}
					})
					.catch(function (error) {
						self.isValidateErrors = true;
						self.isServerVerify = false;
						self.phoneVerifyError = 'Отправка кода невозможна, попробуйте позже';
						console.log("sendPhoneCode: Отправка кода невозможна, попробуйте позже");
						self.inputPhoneCodeEnabled = false;
					});
			},

			sendEmailCode: function (event) {
				event.stopPropagation();
				if (this.email == '') {
					return;
				}

				const self = this;
				self.inputEmailCodeEnabled = false;
				self.sendEmailCodeAgainEnabled = false;

				console.log("sendEmailCode");

				self.emailVerifyError = '';
				self.isEmailVerified = 0;
				self.emailCode = '';
				self.inputCode = "";

				axios.post('/Profiles/SendEmailCode/' + formId + '/' + self.email)
					.then(function (response) {
						if (response.data.isSuccess) {
							console.log("sendEmailCode: отправка успешная");

							self.counter = self.lifeTimeCode;
							self.counterEmail = self.lifeTimeCode;
							self.timerEmailShow = true;
						
							self.countdownEmail();


							
							self.inputEmailCodeEnabled = true;
						}
						if (!response.data.isSuccess) {

							self.counter = self.lifeTimeCode;
							self.counterEmail = self.lifeTimeCode;
							self.timerEmailShow = true;

						
							self.countdownEmail();

							
							self.isValidateErrors = true;
							self.isServerVerify = false;
							self.emailVerifyError = response.data.message.join('');
							console.log("sendEmailCode: отправка неуспешная");
							self.inputEmailCodeEnabled = true;
						}

					})
					.catch(function (error) {
						self.isValidateErrors = true;
						self.isServerVerify = false;
						self.emailVerifyError = 'Отправка кода невозможна, попробуйте позже';
						console.log("sendEmailCode: Отправка кода невозможна, попробуйте позже");
						self.inputEmailCodeEnabled = false;
					});

				event.stopPropagation();
			},

			verifyPhoneCode: async function () {
				var self = this;
				this.isValidateErrors = false;
				console.log("verifyPhoneCode");

				var realPhone = this.fixPhone(this.phone);
				if (!this.isValidatePhone(this.phone)) {
					return;
				}

				return await axios.post('/Profiles/VerifyCode', {
					Phone: realPhone,
					VerificationCode: self.phoneCode
				})
					.then(function (response) {
						if (response.data.isSuccess) {
							self.phoneVerifyError = '';
							console.log("verifyPhoneCode: верификация успешная");
	
						}
						else {
							self.phoneVerifyError = response.data.message.join();
							self.isValidateErrors = true;
							console.log("verifyPhoneCode: верификация неуспешная");
							
						}
						return response.data.isSuccess;
					})
					.catch(function (error) {
						self.isValidateErrors = true;
						console.log("verifyPhoneCode: верификация неуспешная");
						return false;
					});
			},

			verifyEmailCode: async function () {
				var self = this;
				this.isValidateErrors = false;

				console.log("verifyEmailCode");

				return await axios.post('/Profiles/VerifyCode', {
					Login: formId,
					Email: self.email,
					VerificationCode: self.emailCode
				})
					.then(function (response) {
						if (response.data.isSuccess) {
							self.emailVerifyError = '';
							console.log("verifyEmailCode: верификация успешная");
					
						}
						else {
							self.emailVerifyError = response.data.message.join();
							self.isValidateErrors = true;
							console.log("verifyEmailCode: верификация неуспешная");
						}
						return response.data.isSuccess;
					})
					.catch(function (error) {
						self.isValidateErrors = true;
						console.log("verifyEmailCode: верификация неуспешная");
						return false;
					});
			},

			verifyEmailCheckCode: async function (event) {

				event.stopPropagation();
				this.isEmailVerified = 0;

				if (this.emailCode == '') {
					return;
				}

				if (await this.verifyEmailCode()) {
					this.isEmailVerified = 1;

					this.emailProfileRemoveEnabled = true;
				}
				else {
					this.isEmailVerified = -1;
				}
			},

			verifyPhoneCheckCode: async function (event) {

				event.stopPropagation();
				this.isPhoneVerified = 0;

				if (this.phoneCode == '') {
					return;
				}

				var v = await this.verifyPhoneCode();

				if (v) {
					this.isPhoneVerified = 1;

					this.phoneProfileRemoveEnabled = true;
				}
				else {
					this.isPhoneVerified = -1;

				}

			},

			cancelRemoveProfile: function () {
			},

			logOutProfile: function () {
				window.location.href = "/Account/Logout";
			},

			removeProfile: function (event) {
				//event.stopPropagation();
				event.preventDefault();
				var self = this;
				this.isValidateErrors = false;

				axios.post('/Profiles/RemoveProfile', {
					
				})
					.then(function (response) {
						console.log(response);
						//self.serverResponse = response.data;
						if (response.status == 200) {
							self.logOutProfile();
						}
					})
					.catch(function (error) {
						console.log(error)
						self.isValidateErrors = true;
						self.serverMessage = ['Удаление профиля невозможно, попробуйте позже']
					});
			},

        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/RemoveProfile.vue